module.exports = __webpack_public_path__ + "img/header-logo.577ab5f3.png";